module.exports = __webpack_public_path__ + "c486f8214dfde6c181cfd553b2477952.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Racers/racer_teal.png
// module id = 654
// module chunks = 0